const RANKING_ITEMS = [
  {
    rank: 1,
    title: '香蕉视频 · 动作大片合集',
    platform: '香蕉视频',
    heat: '本周最热',
    trend: 'up',
    desc: '收录近三个月评分最高的动作电影，含好莱坞巨制与华语功夫经典。',
  },
  {
    rank: 2,
    title: '西瓜视频免费 · 喜剧之王',
    platform: '西瓜视频免费',
    heat: '持续升温',
    trend: 'up',
    desc: '沈腾、黄渤等喜剧大咖经典作品大合集，笑到停不下来。',
  },
  {
    rank: 3,
    title: '蜜桃视频 · 甜宠剧场',
    platform: '蜜桃视频',
    heat: '新晋热门',
    trend: 'up',
    desc: '最受欢迎都市甜宠剧专题，高颜值主演阵容，每周持续更新。',
  },
  {
    rank: 4,
    title: '樱花视频 · 治愈动漫',
    platform: '樱花视频',
    heat: '稳定热门',
    trend: 'stable',
    desc: '日系治愈向动漫作品精选，从经典老番到新番一应俱全。',
  },
  {
    rank: 5,
    title: '水果视频在线 · 爆笑综艺',
    platform: '水果视频在线',
    heat: '暑期飙升',
    trend: 'up',
    desc: '集结各大综艺平台最受欢迎真人秀，暑期特别策划已上线。',
  },
  {
    rank: 6,
    title: '植物视频平台 · 自然纪录',
    platform: '植物视频平台',
    heat: '口碑之选',
    trend: 'stable',
    desc: 'BBC、国家地理等顶级纪录片频道精选，画面震撼内容优质。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              热度榜单
            </h2>
            <p className="text-sm text-foreground-500">实时追踪各水果视频在线平台热门内容排行</p>
          </div>
          <span className="hidden sm:flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-refresh-line"></i> 每日更新
          </span>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="flex items-start gap-3 md:gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center shrink-0 font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-secondary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {item.platform}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-1.5">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 text-xs">
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line text-accent-600' : 'ri-subtract-line text-foreground-400'}`}></i>
                  <span className="text-foreground-400">{item.heat}</span>
                </div>
              </div>

              <div className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-500 text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}